module.exports = __webpack_public_path__ + "login2x.cbe7894f662ce90a141c.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/login/login2x.png
// module id = ../../../../../src/assets/layout/images/login/login2x.png
// module chunks = 2